import { useMortgageQuery } from 'components/buyer/mortgage/useMortgageApi';

import { MortgageActiveLoanDocument } from '../mortgage/__generated__/mortgage.zeus';
import type { MortgageLoan } from './mortgageLoanCardModel';

const variables = {};

interface UseMortgageLoanResult {
  loan: MortgageLoan | null;
  isLoading: boolean;
}

/** Fetches the signed-in buyer's active mortgage loan for the hub's mortgage section. */
export const useMortgageLoan = (): UseMortgageLoanResult => {
  const { data, loading } = useMortgageQuery(MortgageActiveLoanDocument, { variables });
  return { loan: data?.customerAccount.buyer.mortgage.activeLoan ?? null, isLoading: loading };
};
